import React from 'react';
import Modal from '@components/widgets/Modal';
import Button from '@components/forms/Button';

interface DeclineRequestModalProps {
  open: boolean;
  row: any;
  showSuccessMessage: boolean;
  onClose: () => void;
  onConfirm: (row?: any) => void;
}

const DeclineRequestModal: React.FC<DeclineRequestModalProps> = ({
  open,
  row,
  showSuccessMessage,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal title="Decline Request" size="md" open={open} onClose={onClose}>
      <div className="flex flex-col gap-[10px] p-2">
        {showSuccessMessage ? (
          <div className="text-green-700 text-center mb-4">
            Request successfully declined.
          </div>
        ) : (
          <>
            <div className="text-grey-800 text-base font-medium pb-2">
              Are you sure you want to decline access for{row?.firstName || row?.lastName ? ` ${row?.firstName ?? ''} ${row?.lastName ?? ''}` : ''} ({row?.email})?
            </div>
            <div className="flex justify-end gap-2 pt-4">
              <Button 
                type="button"
              className="border bg-white border-grey-300 text-grey-700 normal-case font-semibold rounded-lg text-sm py-2 px-4 w-full focus:ring-2 focus:ring-offset-1 focus:ring-primary-focus"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                type="button"
                className="font-semibold bg-primary normal-case rounded-lg text-sm text-white w-full py-2 px-4 whitespace-nowrap hover:bg-primary-dark focus:ring-2 focus:ring-offset-1 focus:ring-primary-focus" // Adjusted styling
                onClick={() => onConfirm(row)}
              >
                Decline
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default DeclineRequestModal;
              